import React from 'react';
import { useTranslation } from 'react-i18next';
import { Button } from '../../../ui/Button/Button';

export interface CanceledBannerProps {
  /** When the user's access actually ends. */
  accessEndsAt?: Date | string;
  onReactivate?: () => void;
}

export function CanceledBanner({ accessEndsAt, onReactivate }: CanceledBannerProps) {
  const { t } = useTranslation('m-billing');
  const date = accessEndsAt ? new Date(accessEndsAt).toLocaleDateString() : '—';
  return (
    <div className="flex flex-col gap-2 rounded-xl border border-gray-200 bg-gray-50 p-4 sm:flex-row sm:items-center sm:justify-between">
      <div className="flex flex-col gap-0.5">
        <h4 className="text-sm font-semibold text-gray-800">
          {t('subscription.status.canceled')}
        </h4>
        <p className="text-sm text-gray-600">
          {t('subscription.fields.next_renewal')}: {date}
        </p>
      </div>
      {onReactivate && (
        <Button onClick={onReactivate} variant="outline" className="self-start sm:self-auto">
          {t('subscription.actions.resume')}
        </Button>
      )}
    </div>
  );
}
